import { config } from '@/utils/config';

/**
 * The auth service base URL. Pages that call the auth service build their
 * request URLs on it and send them with fetch.
 */
export const apiClient = {
  getBaseURL(): string {
    return config.authServiceUrl;
  },
};

export default apiClient;
